export const getIsoStringFromDateTime = (date: string) => {
  return new Date(date).toISOString();
};

export const getDateTimeFromIso = (date: string) => {
  return new Date(date).getTime();
};
